import { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  DialogActions,
  Typography,
} from "@mui/material";
import postApiData from "../../../../../hooks/apiRequests/postsRequest";

const buttonSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  whiteSpace: "nowrap",
};

const ResetPassword = ({ data, theme }) => {
  const [openModal, setOpenModal] = useState(false);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleModal = () => {
    setOpenModal((prev) => !prev);
    setError("");
  };

  const handleConfirm = async () => {
    setSaving(true);
    try {
      const response = await postApiData("/User/ResetPassword", {
        email: data?.email,
        name: data?.name,
      });
      if (response) {
        setError("");
        handleModal();
      } else {
        setError("Could not send password reset email.");
      }
    } catch (err) {
      console.error(`Error processing Add request:`, err);
      setError("API update error. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Button
        onClick={handleModal}
        variant="outlined"
        theme={theme}
        fullWidth
        sx={buttonSx}
      >
        Reset password
      </Button>
      <Dialog open={openModal} onClose={handleModal} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 600 }}>Send reset email</DialogTitle>
        <DialogContent>
          <Stack spacing={1}>
            <Typography variant="body2" color="text.secondary">
              This will email the user a password reset link. Are you sure you want
              to continue?
            </Typography>
            {error ? (
              <Typography variant="body2" color="error">
                {error}
              </Typography>
            ) : null}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleModal} color="inherit" sx={buttonSx} theme={theme}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            color="primary"
            disabled={saving}
            theme={theme}
            sx={buttonSx}
          >
            {saving ? "Sending..." : "Send email"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ResetPassword;
